<template>
  <div class="FichePortraitIndexTextuel">
    <page v-for="(page, index) in pages" :key="index">
      <page-inner>
        <fiche class="fiche-container ProjectTextIndex__fiche-container">
          <FichePortraitIndexTextuelCommon
            :date="date"
            :key="index"
            :index="index + 1"
            :title="title"
            :titlesecond="titlesecond"
            :total="pages.length"
          >
            <tr v-for="p in page" :key="p.uuid">
              <td>
                <p>
                  <span class="text-bold">{{ p.name }}</span
                  ><br /><span class="text-reg">{{
                    sortProgrammes(p.programs.map(p => p.name)).join(" ")
                  }}</span>
                </p>
              </td>
              <td>
                <p>
                  <span>{{ p.city }}&nbsp;({{ p.zipcode.slice(0, 2) }})</span
                  ><br />
                  <span v-if="getLatestDate(p)"
                    ><span class="text-light">{{ getLatestDate(p).text }}</span>
                    {{ extractYear(getLatestDate(p).content) }}</span
                  >
                </p>
              </td>
              <td>
                <p>
                  <span v-if="getMaitrise(p)">{{
                    getMaitrise(p).join(", ")
                  }}</span>
                </p>
              </td>
              <td>
                <p>
                  <span class="text-regular">{{
                    getArchitectesWithMandataireDistinction(p)
                      .map(p => filterScalene(p))
                      .join(", ")
                  }}</span>
                </p>
              </td>
              <td>
                <p>{{ p.procedures.map(p => p.name).join(" ") }}</p>
              </td>
              <td>
                <p>
                  <span v-if="p.surfaces.length > 0"
                    >{{ formatNumbers(getBiggestSurface(p).content) }}m²</span
                  ><br /><span v-if="p.cost != null"
                    >{{ formatNumbersFrench(p.cost) }}€</span
                  >
                </p>
              </td>
              <svg width="100%" height="1px">
                <path
                  style="fill:none;fill-opacity:1;stroke:#31287c;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="M 0,0 H 5000"
                />
              </svg>
            </tr>
            <tr class="sweepMark">
              <svg width="100%" height="1px">
                <path
                  style="fill:none;fill-opacity:1;stroke:#31287c;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="M 0,0 H 5000"
                />
              </svg>
            </tr>
          </FichePortraitIndexTextuelCommon>
        </fiche>
      </page-inner>
    </page>
  </div>
</template>

<script>
import Fiche from "../../../../PrintComponents/Fiche/Fiche";
import PageInner from "../../../../PrintComponents/Page/PageInner";
import {
  extractYear,
  filterScalene,
  formatNumbers,
  formatNumbersFrench,
  getAmenageurs,
  getArchitectes,
  getArchitectesWithMandataireDistinction,
  getLatestDate,
  getBiggestSurface,
  getUser,
  getMaitrise,
  mapNames,
  sortProgrammes
} from "../../../../../../util/func";
import FichePortraitIndexTextuelCommon from "./FichePortraitIndexTextuelCommon";
import Page from "../../../../PrintComponents/Page/Page";

export default {
  name: "FichePortraitIndexTextuel",
  components: {
    Page,
    FichePortraitIndexTextuelCommon,
    Fiche,
    PageInner
  },
  data() {
    return {
      pages: [],
      laying: 0
    };
  },
  computed: {
    ratio() {
      return this.$store.state.drawing.ratio;
    },
    date() {
      return new Date().toLocaleDateString();
    }
  },
  props: {
    format: {},
    projets: {},
    index: {},
    title: {},
    titlesecond: {},
    p: {},
    pm: {},
    cols: {}
  },
  methods: {
    async layProjects() {
      if (this.laying) return;
      this.laying = 1;
      this.pages = [];
      let pageIndex = 0;
      this.pages.push([]);
      let p = this.projets.slice(0);
      await new Promise(r => setTimeout(r, 50));
      while (p.length > 0) {
        this.pages[pageIndex].push(p.shift());
        await new Promise(r => setTimeout(r, 16));
        const pageInside = document.querySelectorAll(".PPage .fiche-container")[
          pageIndex
        ];
        const sweepMark = document.querySelectorAll(
          ".PPage .fiche-container .sweepMark"
        )[pageIndex];
        if (
          this.overflows(
            pageInside.getBoundingClientRect(),
            sweepMark.getBoundingClientRect()
          )
        ) {
          const overflowing = this.pages[pageIndex].pop();
          this.pages.push([overflowing]);
          this.$root.$emit("DRAWING_SPACE_MOVED", this.pages.length);
          pageIndex += 1;
        }
        await new Promise(r => setTimeout(r, 16));
        this.$root.$emit("DRAWING_SPACE_MOVED", this.pages.length);
      }
      this.$emit("pages", this.pages.length);
      this.laying = 0;
    },
    overflows(a, b) {
      return a.y + a.height <= b.y + b.height;
    },
    mapNames,
    filterScalene,
    formatNumbersFrench,
    formatNumbers,
    extractYear,
    sortProgrammes,
    getAmenageurs,
    getArchitectes,
    getLatestDate,
    getBiggestSurface,
    getArchitectesWithMandataireDistinction,
    getUser,
    getMaitrise
  },
  mounted() {
    this.layProjects();
  },
  watch: {
    projets() {
      this.layProjects();
    },
    title(val, old) {
      if (val.length === 0 || old.length === 0) this.layProjects();
    }
  }
};
</script>
